export default __webpack_public_path__ + "static/media/Tishknet.e6b8c7c6.png";